import React, { Component } from "react";
export default class LanguageSpellingSection extends Component {
  render() {
    var {
      spelling_envelop_text_status,
      spelling_envelop_text,
      spelling_skate_board_text_status,
      spelling_skate_board_text,
      spelling_constructing_text_status,
      spelling_constructing_text,
      spelling_partner_text_status,
      spelling_partner_text,
      spelling_biscuit_text_status,
      spelling_biscuit_text,
      spelling_lawnmower_text_status,
      spelling_lawnmower_text,
      spelling_deliver_text_status,
      spelling_deliver_text,
      spelling_recorded_text_status,
      spelling_recorded_text,
      spelling_coarhanger_text_status,
      spelling_coarhanger_text,
      spelling_orchestra_text_status,
      spelling_orchestra_text,
      spelling_screwdriver_text_status,
      spelling_screwdriver_text,
      spelling_score,
      spelling_brought_text_status,
      spelling_brought_text,
    } = this.props.data;
    return (
      <div className="row border border-dark">
        <div className="col-lg-12">
          <table className="w-100">
            <tbody>
              <tr>
                <td>
                  <br />
                  <ul
                    style={{
                      paddingLeft: 20,
                      fontSize: 19,
                    }}
                  >
                    <li style={{ listStyle: "square" }}>
                      Administration:
                      <ul style={{ paddingLeft: 40 }}>
                        <li
                          style={{
                            listStyle: "circle",
                          }}
                        >
                          Unlimited time is given for spelling of each word. All
                          words are assessed even if early words in the list are
                          incorrect. Move on to the next word if participant is
                          unable or unwilling to attempt spelling of one word.
                          The word may be clearly stated by the interviewer
                          several times if necessary. For example, if the
                          participant spells ‘constructing’ as ‘construction’,
                          restate the word clearly. Similarly, if the plural of
                          the word is spelled e.g., ‘biscuits’ instead of
                          ‘biscuit’, restate the target word clearly.
                        </li>
                      </ul>
                    </li>
                    <li style={{ listStyle: "square" }}>
                      Scoring:
                      <ul style={{ paddingLeft: 40 }}>
                        <li
                          style={{
                            listStyle: "circle",
                          }}
                        >
                          Self-corrections are allowed; only the final answer is
                          taken for scoring
                        </li>
                        <li
                          style={{
                            listStyle: "circle",
                          }}
                        >
                          Caution should be taken in interpretation where low
                          premorbid IQ or a history of reading or spelling
                          difficulties is reported. It is recommended
                          interviewer ask patient and/or carer about premorbid
                          reading abilities.
                        </li>
                      </ul>
                    </li>
                    <li style={{ listStyle: "square" }}>
                      Say:
                      <ul style={{ paddingLeft: 40 }}>
                        <li
                          style={{
                            listStyle: "circle",
                          }}
                        >
                          Spell the following words{" "}
                        </li>
                      </ul>
                      <br />
                    </li>
                  </ul>
                  <div className="row p-3">
                    <div className="col-lg-6">
                      <span className="fs-19">1. Envelope </span>{" "}
                      <input
                        className="position-relative"
                        style={{
                          width: 20,
                          top: 3,
                          left: 9,
                        }}
                        type="checkbox"
                        checked={
                          spelling_envelop_text_status == "1" ? true : false
                        }
                        name="spelling_envelop_text_status"
                      />
                      <input
                        value={spelling_envelop_text}
                        name="spelling_envelop_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <span className="fs-19">2. Skateboard </span>{" "}
                      <input
                        className="position-relative"
                        style={{
                          width: 20,
                          top: 3,
                          left: 9,
                        }}
                        type="checkbox"
                        checked={
                          spelling_skate_board_text_status == "1" ? true : false
                        }
                        name="spelling_skate_board_text_status"
                      />
                      <input
                        value={spelling_skate_board_text}
                        name="spelling_skate_board_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <span className="fs-19">3. Constructing </span>
                      <input
                        className="position-relative"
                        style={{
                          width: 20,
                          top: 3,
                          left: 9,
                        }}
                        type="checkbox"
                        checked={
                          spelling_constructing_text_status == "1"
                            ? true
                            : false
                        }
                        name="spelling_constructing_text_status"
                      />
                      <input
                        value={spelling_constructing_text}
                        name="spelling_constructing_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <span className="fs-19">4. Partner </span>{" "}
                      <input
                        className="position-relative"
                        style={{
                          width: 20,
                          top: 3,
                          left: 9,
                        }}
                        type="checkbox"
                        checked={
                          spelling_partner_text_status == "1" ? true : false
                        }
                        name="spelling_partner_text_status"
                      />
                      <input
                        value={spelling_partner_text}
                        name="spelling_partner_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <span className="fs-19">5. Biscuit </span>
                      <input
                        className="position-relative"
                        style={{
                          width: 20,
                          top: 3,
                          left: 9,
                        }}
                        type="checkbox"
                        checked={
                          spelling_biscuit_text_status == "1" ? true : false
                        }
                        name="spelling_biscuit_text_status"
                      />{" "}
                      <input
                        value={spelling_biscuit_text}
                        name="spelling_biscuit_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <span className="fs-19">6. Lawnmower </span>{" "}
                      <input
                        className="position-relative"
                        style={{
                          width: 20,
                          top: 3,
                          left: 9,
                        }}
                        type="checkbox"
                        checked={
                          spelling_lawnmower_text_status == "1" ? true : false
                        }
                        name="spelling_lawnmower_text_status"
                      />
                      <input
                        value={spelling_lawnmower_text}
                        name="spelling_lawnmower_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <span className="fs-19">7. Deliver </span>{" "}
                      <input
                        className="position-relative"
                        style={{
                          width: 20,
                          top: 3,
                          left: 9,
                        }}
                        type="checkbox"
                        checked={
                          spelling_deliver_text_status == "1" ? true : false
                        }
                        name="spelling_deliver_text_status"
                      />
                      <input
                        value={spelling_deliver_text}
                        name="spelling_deliver_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <span className="fs-19">8. Recorded </span>{" "}
                      <input
                        className="position-relative"
                        style={{
                          width: 20,
                          top: 3,
                          left: 9,
                        }}
                        type="checkbox"
                        checked={
                          spelling_recorded_text_status == "1" ? true : false
                        }
                        name="spelling_recorded_text_status"
                      />
                      <input
                        value={spelling_recorded_text}
                        name="spelling_recorded_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <span className="fs-19">9. Coathanger </span>{" "}
                      <input
                        className="position-relative"
                        style={{
                          width: 20,
                          top: 3,
                          left: 9,
                        }}
                        type="checkbox"
                        checked={
                          spelling_coarhanger_text_status == "1" ? true : false
                        }
                        name="spelling_coarhanger_text_status"
                      />
                      <input
                        value={spelling_coarhanger_text}
                        name="spelling_coarhanger_text"
                        type="text"
                        className="ecas-input-field"
                      />
                      {spelling_coarhanger_text
                        ? spelling_coarhanger_text
                        : "Nothing"}
                    </div>
                    <div className="col-lg-6">
                      <span className="fs-19">10. Orchestra </span>{" "}
                      <input
                        className="position-relative"
                        style={{
                          width: 20,
                          top: 3,
                          left: 9,
                        }}
                        type="checkbox"
                        checked={
                          spelling_orchestra_text_status == "1" ? true : false
                        }
                        name="spelling_orchestra_text_status"
                      />
                      <input
                        value={spelling_orchestra_text}
                        name="spelling_orchestra_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <span className="fs-19">11. Screwdriver </span>{" "}
                      <input
                        className="position-relative"
                        style={{
                          width: 20,
                          top: 3,
                          left: 9,
                        }}
                        type="checkbox"
                        checked={
                          spelling_screwdriver_text_status == "1" ? true : false
                        }
                        name="spelling_screwdriver_text_status"
                      />
                      <input
                        value={spelling_screwdriver_text}
                        name="spelling_screwdriver_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <span className="fs-19">12. Brought </span>
                      <input
                        className="position-relative"
                        style={{
                          width: 20,
                          top: 3,
                          left: 9,
                        }}
                        type="checkbox"
                        checked={
                          spelling_brought_text_status == "1" ? true : false
                        }
                        name="spelling_brought_text_status"
                      />
                      <input
                        value={spelling_brought_text}
                        name="spelling_brought_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                  </div>
                  <hr />
                  <div className="col-lg-6">
                    <span className="fs-19">Score (0-12) </span>
                    <input
                      type="number"
                      disabled
                      name="spelling_score"
                      value={spelling_score}
                      className="ecas-input-field"
                      placeholder="Score"
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
